import { useArtGeneratorViewController } from 'modules/art/controllers';
import { EnteringEmailView } from '../CreateArtView/EnterEmailView';
import { ConfirmEmailView } from '../CreateArtView/ConfirmEmailView';
import { FinishSelectView } from '../CreateArtView/FinishSelectView';
import { ShowReadyArtView } from './ShowReadyArtView';
import { StepModeValue } from 'modules/art/types';

export const CreateReadyArtView = ({ imageId }) => {
  const { ShowReadyArt, ConfirmEmail, EnterEmail, FinishSelect } = StepModeValue;

  const {
    step,
    emailData,
    isStartLoading,
    setStep,
    enterEmail,
    selectVariant,
    toBuilder,
    currentReadyArt,
    download,
    start,
  } = useArtGeneratorViewController(ShowReadyArt, imageId);

  return (
    <>
      {step === ShowReadyArt && (
        <ShowReadyArtView currentReadyArt={currentReadyArt} select={selectVariant} />
      )}

      {step === EnterEmail && (
        <EnteringEmailView goBack={() => setStep(ShowReadyArt)} enterEmail={enterEmail} />
      )}

      {step === ConfirmEmail && (
        <ConfirmEmailView
          isStartLoading={isStartLoading}
          emailData={emailData}
          goBack={() => setStep(EnterEmail)}
          start={start}
        />
      )}

      {step === FinishSelect && (
        <FinishSelectView
          download={download}
          toBuilder={toBuilder}
          isStartLoading={isStartLoading}
        />
      )}
    </>
  );
};
